import { combineReducers } from 'redux'
import { connectRouter } from 'connected-react-router'
import auth from './auth'
import humanResources from './humanResources'
import financial from './financial'
import technicalDep from './technicalDep'
import tasks from './tasks'
import wallet from './wallet'
import agenda from './agenda'
import files from './files'
import customer from './customer'
import patrimony from './patrimony'
import comercial from './comercial'
import types from './types'
import admin from './admin'
import forms from './forms'
import management from './management'

const createRootReducer = history => combineReducers({
  router: connectRouter(history),
  auth,
  humanResources,
  financial,
  technicalDep,
  tasks,
  wallet,
  agenda,
  files,
  customer,
  patrimony,
  comercial,
  types,
  admin,
  forms,
  management,
})

export default createRootReducer
